import { Slice } from "gatsby";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOGGEDIN } from "../constants/auth";
import { GetCustomer } from "../lib/dynamicQueries/account";
import { GetCart } from "../lib/dynamicQueries/cart";
import { getUser, setUser } from "../slices/auth";
import { removeCart, updateCart } from "../slices/cart";
import { getFavorites } from "../slices/wishlist";
import { UseNavbarShop } from "../staticQueries/useNavbarShop";
import { IsBrowser } from "../utils/isBrowser";
import AnnouncementBar from "./AnnouncementBar";
import CountryPopup from "./AnnouncementBar/CountryPopup";
import NewsletterPopup from "./NewsletterPopup/NewsletterPopup";
import {fetchGiftTiers} from "../slices/giftTiers";
import {fetchProductGifts} from "../slices/productGifts";
import {fetchBundles} from "../slices/bundles/utils";

const CART_ID = `bushbuck-cartId-${process.env.GATSBY_LOCALE_COUNTRY}`;

const getCartData = async (dispatch) => {
  if (IsBrowser()) {
    const cartId = localStorage.getItem(CART_ID);
    if (cartId) {
      const response = await GetCart(cartId);
      if (response?.cart) {
        if (response.cart.completed?.value === "true") {
          dispatch(removeCart());
          return;
        }
        dispatch(updateCart(response.cart));
      }
    }
  }
};

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const data = UseNavbarShop();
  const [hideUp, setHideUp] = useState(false);
  const { authState, user } = useSelector((state) => state.auth);
  // const { isClient } = useIsClient();

  const yRef = useRef(0);

  const handleScroll = useCallback(() => {
    const offsetTop = 150;
    if (window.scrollY > offsetTop && yRef.current < window.scrollY) {
      setHideUp(true);
    } else {
      setHideUp(false);
    }
    yRef.current = window.scrollY;
  }, []);

  useEffect(() => {
    if (IsBrowser()) {
      window.addEventListener("scroll", handleScroll);

      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);
  async function getUserDetails() {
    const response = await GetCustomer(user.accessToken);
    if (response) {
      dispatch(setUser(response));
    }
  }

  useEffect(() => {
    if (authState === LOGGEDIN) {
      getUserDetails().then(() => {
        dispatch(getFavorites());
      });
    }
  }, [authState === LOGGEDIN]);

  useEffect(() => {
    getCartData(dispatch);
    dispatch(getUser());
    dispatch(getFavorites());
    dispatch(fetchGiftTiers());
    dispatch(fetchProductGifts());
    dispatch(fetchBundles());
  }, [dispatch]);

  return (
    <div className="flex flex-col w-full min-h-screen overflow-x-hidden">
      <div
        className={`fixed top-0 left-0 w-full z-20 transform transition-all duration-500 ${
          hideUp ? "-translate-y-52" : "translate-y-0"
        }`}
      >
        <AnnouncementBar
          title={data.helpLinksHeading}
          bgImage={data.helpBG}
          helpLinks={data.helpLinks}
          footerLinks={data.helpFooterLinks}
          contactDetails={data.contactDetails}
        />
        <Slice alias="navbar" data={data} />
      </div>
      <div className="mt-[90px] lg:mt-32">{children}</div>
      <Slice alias="footer" />
      <CountryPopup />
      <NewsletterPopup />
    </div>
  );
};

export default Layout;
